export const TOOLTIP_CONFIG = {
  enabled: false,
  intersect: false,
  mode: 'nearest',
  axis: 'x'
} as const
